import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_API_URL || '/api';

export const planApi = createApi({
  reducerPath: 'planApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Plan'],
  endpoints: (builder) => ({
    // Get all plans
    getPlans: builder.query({
      query: (country) => {
        console.log('Plan API Debug - Country parameter:', country);
        const params = country ? { country } : {};
        console.log('Plan API Debug - Query params:', params);
        return {
          url: '/plans',
          params
        };
      },
      transformResponse: (response) => {
        console.log('Plan API Debug - Raw response:', response);
        return response.success ? response.data : [];
      },
      providesTags: (result, error, country) => [
        { type: 'Plan', id: `country-${country || 'all'}` },
        'Plan'
      ],
      forceRefetch: ({ currentArg, previousArg }) => {
        return currentArg !== previousArg;
      }
    }),

    // Get plan by ID
    getPlan: builder.query({
      query: (id) => `/plans/${id}`,
      providesTags: (result, error, id) => [{ type: 'Plan', id }],
    }),

    // Create plan (Admin only)
    createPlan: builder.mutation({
      query: (plan) => ({
        url: '/plans',
        method: 'POST',
        body: plan,
      }),
      invalidatesTags: ['Plan'],
    }),

    // Update plan (Admin only)
    updatePlan: builder.mutation({
      query: ({ id, ...plan }) => ({
        url: `/plans/${id}`,
        method: 'PUT',
        body: plan,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Plan', id },
        'Plan',
      ],
    }),

    // Delete plan (Admin only)
    deletePlan: builder.mutation({
      query: (id) => ({
        url: `/plans/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Plan'],
    }),
  }),
});

export const {
  useGetPlansQuery,
  useGetPlanQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
  useDeletePlanMutation,
} = planApi;
